// Every window event the shell dispatches when the account, the profile list or the
// active profile changes. host.profile.onChange covers all of them, so apps never
// listen to shell events or read account keys themselves.
const PROFILE_CHANGE_EVENTS = [
  'storage',
  'yada:account-change',
  'yada:account:updated',
  'yada:profiles:updated',
  'yada:profile:changed',
] as const;

export function onProfileChange(cb: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const handler = () => cb();
  for (const event of PROFILE_CHANGE_EVENTS) window.addEventListener(event, handler);
  return () => {
    for (const event of PROFILE_CHANGE_EVENTS) window.removeEventListener(event, handler);
  };
}
